module.exports = __webpack_public_path__ + "media/pl_pl_s2_Elzbieta.796357e4.mp3";